// extracted by mini-css-extract-plugin
export default {"paused":"product-list-paused_paused__h+iPL","paused_heading":"product-list-paused_paused_heading__ME6PQ","paused_heading_label":"product-list-paused_paused_heading_label__olJdE"};